/**
 * Ringtone Helper Utility
 * Generates and manages ringtone sound for incoming calls
 */

class RingtoneHelper {
    constructor() {
        this.audioContext = null;
        this.oscillator = null;
        this.gainNode = null;
        this.isPlaying = false;
    }

    /**
     * Initialize audio context (must be called after user interaction)
     */
    init() {
        if (!this.audioContext) {
            this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
        }
    }

    /**
     * Play ringtone with repeating pattern
     */
    play() {
        if (this.isPlaying) return;

        this.init();
        this.isPlaying = true;
        this.playRingPattern();
    }

    /**
     * Play a single ring pattern (similar to phone ringtone)
     */
    playRingPattern() {
        if (!this.isPlaying || !this.audioContext) return;

        // Create oscillator for the tone
        this.oscillator = this.audioContext.createOscillator();
        this.gainNode = this.audioContext.createGain();

        // Connect nodes
        this.oscillator.connect(this.gainNode);
        this.gainNode.connect(this.audioContext.destination);

        // Set tone parameters (pleasant phone-like tone)
        this.oscillator.frequency.value = 520; // C5 note
        this.gainNode.gain.value = 0.3; // Moderate volume

        // Start the tone
        this.oscillator.start();

        // Create a pattern: tone for 0.4s, pause 0.2s, tone for 0.4s, pause 2s, repeat
        setTimeout(() => {
            if (this.oscillator) {
                this.oscillator.stop();
                this.oscillator = null;
            }

            if (this.isPlaying) {
                setTimeout(() => {
                    if (this.isPlaying) {
                        this.playSecondTone();
                    }
                }, 200);
            }
        }, 400);
    }

    /**
     * Play second tone in the pattern
     */
    playSecondTone() {
        if (!this.isPlaying || !this.audioContext) return;

        this.oscillator = this.audioContext.createOscillator();
        this.gainNode = this.audioContext.createGain();

        this.oscillator.connect(this.gainNode);
        this.gainNode.connect(this.audioContext.destination);

        this.oscillator.frequency.value = 520;
        this.gainNode.gain.value = 0.3;

        this.oscillator.start();

        setTimeout(() => {
            if (this.oscillator) {
                this.oscillator.stop();
                this.oscillator = null;
            }

            // Wait 2 seconds before repeating the pattern
            if (this.isPlaying) {
                setTimeout(() => {
                    if (this.isPlaying) {
                        this.playRingPattern();
                    }
                }, 2000);
            }
        }, 400);
    }

    /**
     * Stop playing ringtone
     */
    stop() {
        this.isPlaying = false;

        if (this.oscillator) {
            try {
                this.oscillator.stop();
            } catch (e) {
                // Oscillator might already be stopped
            }
            this.oscillator = null;
        }

        if (this.gainNode) {
            this.gainNode = null;
        }
    }

    /**
     * Cleanup resources
     */
    destroy() {
        this.stop();
        if (this.audioContext) {
            this.audioContext.close();
            this.audioContext = null;
        }
    }
}

// Create and export singleton instance
const ringtone = new RingtoneHelper();

export default ringtone;
